import { useEffect, useState } from "react";
import { Button, Input, Modal, message } from "antd";
import "./Modal_Offers.scss";
import { formatNumber } from "../../helper/fomartNum";
import { priceNew } from "../../helper/priceNew";
import { PiClockCounterClockwise } from "react-icons/pi";
import { Link } from "react-router-dom";
import { postOffer } from "../../services/user/user";

function Modal_Offers({
  isModalOpen,
  handleCancel,
  productsDetails,
  userByToken,
}) {
  const products = productsDetails[0];
  const giaGoc = priceNew(products.price_old, products.sales);
  const [offerPrice, setOfferPrice] = useState("");
  const [modalStep, setModalStep] = useState("form");
  const [messageApi, contextHolder] = message.useMessage();

  const handleChangePrice = (e) => {
    const value = Number(e.target.value);

    if (e.target.value === "") {
      setOfferPrice("");
      return;
    }

    if (value < 0) {
      messageApi.open({
        type: "warning",
        content: "Giá không được nhỏ hơn 0!",
      });
      return;
    }

    if (value > giaGoc) {
      messageApi.open({
        type: "warning",
        content: "Giá đề nghị không được lớn hơn giá gốc!",
      });
      return;
    }

    setOfferPrice(value);
  };

  const handleSubmit = async () => {
    if (!offerPrice) {
      messageApi.open({
        type: "warning",
        content: "Vui lòng nhập giá đề nghị!",
      });
      return;
    }

    const data = {
      productId: products.id,
      shopOwner: products.name_shop,
      userId: userByToken.id,
      username: userByToken.username,
      offerPrice: offerPrice,
      originalPrice: giaGoc,
      status: "pending",
      createdAt: new Date().toISOString(),
    };

    try {
      await postOffer(data); // chỉ gửi offer, không cập nhật giá thật
      messageApi.open({ type: "success", content: "Đã gửi đề nghị giá!" });
      setModalStep("success");
    } catch (err) {
      console.error(err);
      messageApi.open({
        type: "error",
        content: "Gửi đề nghị thất bại. Vui lòng thử lại.",
      });
    }
  };

  const handleClose = () => {
    setModalStep("form");
    setOfferPrice("");
    handleCancel();
  };

  // console.log("userByToken:", userByToken);

  return (
    <>
      {contextHolder}
      <Modal
        centered
        width={500}
        open={isModalOpen}
        onCancel={handleClose}
        footer={null}
        mask={true}
        zIndex={2000}
      >
        {modalStep === "form" ? (
          <div className="modal-offers">
            <div className="offers-title">Đề nghị giá mới</div>

            <div className="info-products">
              <div className="img-products">
                <img src={products.thumbnail1} alt="Image Products" />
              </div>
              <div className="details-products">
                <div className="details-size">{products.size}</div>
                <div className="details-price">
                  Giá: {formatNumber(giaGoc)}
                  <span className="underline">đ</span>
                </div>
              </div>
            </div>

            <div className="info-newPrice">
              <div className="newPrice-title">Nhập giá mong muốn của bạn</div>
              <Input
                type="number"
                className="input-price"
                value={offerPrice}
                onChange={handleChangePrice}
              />
            </div>

            <Button className="btn-offers" onClick={handleSubmit}>
              Gửi đề nghị
            </Button>

            <div className="info-sub">
              <PiClockCounterClockwise className="info-sub-icon" />
              <div className="sub-details">
                Lời đề nghị không phải là giao dịch mua. Nếu người bán chấp
                nhận, bạn sẽ có 24 giờ để mua sản phẩm với giá đề nghị.
              </div>
            </div>
          </div>
        ) : (
          <div className="modal-offers-success">
            <div className="success-title">Đã gửi đề nghị giá</div>
            <div className="success-img">
              <img
                src="https://assets.depop.com/web/assets/make-offer-spin-sticker.gif"
                alt="Image Offers Success"
              />
            </div>

            <div className="success-sub">
              Đã gửi đề nghị đến chủ shop. Bạn có thể xem yêu cầu của bạn trong
              hồ sơ
            </div>
            <Link to={`/user/${userByToken[0]?.username}`}>
              <Button className="btn-success-offers">Xem đề nghị</Button>
            </Link>
          </div>
        )}
      </Modal>
    </>
  );
}

export default Modal_Offers;
